import React from 'react';
import {Box, Typography} from '@mui/material';
import './AccordionContent.scss';

type Options = {
  label: string;
  value: string;
};
type AccordionContentProps = {
  description: string;
  options: Options[];
  dataTestId: string;
};

const AccordionContent: React.FC<AccordionContentProps> = (props) => {
  const {description, options, dataTestId} = props;
  return (
    <Box className="analyzer-details-accordion">
      <Typography
        tabIndex={0}
        className="typo-text body2_size analyzer-details-accordion__desc"
        data-testid={`accordion-content-typography`}
      >
        {description}
      </Typography>
      <Box className="analyzer-details-accordion__footer">
        {options?.map((item, index) => (
          <React.Fragment key={item.label}>
            <Typography
              tabIndex={0}
              className="typo-text subhead4_size "
              data-testid={`accordion-content-option-label-${dataTestId}-${index}`}
            >
              {item.label}
            </Typography>
            <Typography
              tabIndex={0}
              className="typo-text body2_size"
              data-testid={`accordion-content-option-value-${dataTestId}-${index}`}
            >
              {item.value}
            </Typography>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default AccordionContent;
